import { memo } from 'react';
import type { ReactElement } from 'react';

import type { ConnectedProps } from 'react-redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { compose } from 'redux';

import { ANALYTICS_EVENTS } from 'src/app/analytics/analyticsEvents';
import { orderTracking } from 'src/app/router/paths';
import { segmentAnalyticsEvent } from 'src/app/state/actions';
import {
  currentlyLoggedInPatientHealthkitRecordsAvailable,
  obtainMagicTokenAction,
} from 'src/app/state/actions/account';
import { getCurrentPathname } from 'src/app/state/selectors';
import type { Dispatch, RootState } from 'src/app/state/store';
import { arePathnamesEqual } from 'src/app/utils';

import { SmartBannerRenderer } from '.';

const mapStateToProps = () => {
  return (state: RootState, ownProps: OwnPropsType) => {
    const accountId = state?.session?.currentAccountId;
    const pathName = getCurrentPathname(state);
    const params = ownProps?.match?.params;
    const isInOrderTracking = arePathnamesEqual(pathName, orderTracking.toPath(params));
    return {
      accountId,
      isInOrderTracking,
      pathName,
      params,
    };
  };
};

const mapDispatchToProps = (dispatch: Dispatch) => ({
  dispatchCurrentlyLoggedInPatientHealthkitRecordsAvailable: () =>
    dispatch(currentlyLoggedInPatientHealthkitRecordsAvailable()),
  dispatchObtainMagicTokenAction: () => dispatch(obtainMagicTokenAction()),
  dispatchShowSmartBanner: (accountId: number | null, pathName: string) =>
    dispatch(segmentAnalyticsEvent(ANALYTICS_EVENTS.showSmartBanner, { accountId, pathName })),
  dispatchClickGetSmartBanner: (accountId: number | null, pathName: string) =>
    dispatch(segmentAnalyticsEvent(ANALYTICS_EVENTS.clickGetSmartBanner, { accountId, pathName })),
  dispatchClickCloseSmartBanner: (accountId: number | null, pathName: string) =>
    dispatch(segmentAnalyticsEvent(ANALYTICS_EVENTS.clickCloseSmartBanner, { accountId, pathName })),
  dispatchCloseSmartBanner: (accountId: number | null, pathName: string) =>
    dispatch(segmentAnalyticsEvent(ANALYTICS_EVENTS.closeSmartBanner, { accountId, pathName })),
});

const connector = connect(mapStateToProps, mapDispatchToProps);
export type PropsFromRedux = ConnectedProps<typeof connector>;

export default compose(withRouter, connector, memo)(SmartBannerRenderer) as () => ReactElement;
